import type { FaireProductEntity } from "../../entity_types/product";

export const p_jv32atw79q: FaireProductEntity = {
  token: "p_jv32atw79q",
  type: "product",
  name: "All-Natural Shampoo Bar. Plastic-Free.",
  brandToken: "b_ttb2n52ngz",
  brandName: "BeNat",
  imageUrl:
    "https://cdn.faire.com/fastly/b18bd72e14581c82d33698fe7cea1a13093147768bdb516b20ce6b34dd5e53c5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/05b1e166cdfb050d1196db62e04f23c9ceff4196bea44374d399f07dd26d59fb.jpeg",
    "https://cdn.faire.com/fastly/10fff9472ef080d9188eb8a4d08fcdbf992992a9b8976391a56857d322dd07c1.png",
    "https://cdn.faire.com/fastly/cfa7a26049b420b064ade85b6600e7818f881018e1b11dc133cc536df262a619.png",
    "https://cdn.faire.com/fastly/52442445e7d9e28d6e9c1808e7065f88f6cf9c49b809d212527256462abd223a.png",
    "https://cdn.faire.com/fastly/9fa99081a55099d4060270a0e83013d14593f06a5230eadf21b9445df5878664.jpeg",
    "https://cdn.faire.com/fastly/c8959820be440c727aa78af9f3f79929d8198febcbe6cb4235cac45d81ab9fa1.jpeg",
    "https://cdn.faire.com/fastly/dbd671e97c391fdfa3a95c6ee916044d9a8b35414ada3505f6b55c67080ffab6.jpeg",
    "https://cdn.faire.com/fastly/521ebf2e50eec28091d6e21b5c898cd3876874a693c5b0d67e05b3c4f64cbdb6.jpeg",
    "https://cdn.faire.com/fastly/5477dca1439c1ba116bcf1761ba3c52d240d71b15dd75824f721ab5a45beb9fc.jpeg",
    "https://cdn.faire.com/fastly/2d8596f4ad9bc402a3853bca1d4a379a2d9caa612471cf4b7a1c63f2ca076b7f.jpeg",
    "https://cdn.faire.com/fastly/f834c5c4a4291d08e99c10b0332d4cd3fdf267409a145b6c62ac87b086ef7037.jpeg",
    "https://cdn.faire.com/fastly/b2e1132b2003697613d5f056e8a4506c88bcd699bc751b75b3158ca38cb88acf.jpeg",
  ],
  priceDollars: 8.99,
  description:
    "Our all-natural ingredients nourish your hair from the roots to the tips. Our amazing bars last up to 50+ washes.\nZero-waste. Eco-friendly. Sulfate-free. Silicone-free. Paraben-free. Cruelty-free. \nHIGH QUALITY. Synthetic-Free (color, fragrance, additives). No GMOs. No harmful ingredients. No foam boosters. Alcohol & petroleum-free. No detergents.\nOur successful formula makes it suitable for all hair types. We use essential oil for its well-known properties without the overpowering scent. No fragrance. Just clean & nourish hair and scalp.\n\nLather the bar in your hands or directly on your head and use it like most shampoos. This amazing bar lasts up to 8 weeks of daily use.\nNet weight: 3.2 oz.",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:09.923Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
